import {Pipe, PipeTransform} from '@angular/core'
import {LoanType, LoanTypeMap} from '@sparbanken-syd/loan-backend'

@Pipe({
  name: 'loanType'
})
export class LoanTypePipe implements PipeTransform {

  transform(value: LoanType) {
    return LoanTypeMap.get(value) as string
  }

}
